import * as React from 'react';
import { Tabs as BaseTabs } from '@base-ui-components/react/tabs';
import { cn } from '@/shared/lib/cn';
import { UnreadBadge } from '../UnreadBadge/UnreadBadge';
import styles from './Tabs.module.css';

/**
 * Переключение между равноправными разделами одного экрана: вкладки карточки
 * заявки, разделы админки.
 *
 * Не для перехода между страницами — там роутер и URL, иначе состояние не
 * переживёт refresh и не пошарится ссылкой. Композиция поверх Base UI:
 * Tabs (корень) + TabsList + TabsTab + TabsPanel.
 *
 * @use переключение равноправных разделов одного экрана. Между страницами — роутер и URL, не вкладки.
 */
export const Tabs = BaseTabs.Root;

export const TabsList = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof BaseTabs.List>
>(function TabsList({ className, ...rest }, ref) {
  return <BaseTabs.List ref={ref} className={cn(styles.list, className)} {...rest} />;
});

export const TabsTab = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof BaseTabs.Tab>
>(function TabsTab({ className, ...rest }, ref) {
  return <BaseTabs.Tab ref={ref} className={cn(styles.tab, className)} {...rest} />;
});

export const TabsPanel = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof BaseTabs.Panel>
>(function TabsPanel({ className, ...rest }, ref) {
  return <BaseTabs.Panel ref={ref} className={cn(styles.panel, className)} {...rest} />;
});

export function TabsCount({ value, unread = 0 }: { value: number; unread?: number }) {
  if (unread > 0) return <UnreadBadge count={unread} aria-label={`Новых: ${unread}`} />;
  return value > 0 ? <span className={styles.count}>{value}</span> : null;
}
